import type * as React from 'react';

import * as api from '@gitbook/api-client';
import {
    Description,
    FieldGroup,
    Group,
    Label,
    Panel,
    PanelBody,
    Switch,
} from '@gitbook/spine-react';

import { useUpgradeSite } from '../../../state';
import { PaidFeatureIndicator } from '../../Site/PaidFeatureIndicator';
import type { SiteOnlyCustomizationProps } from '../types';

/**
 * Settings to enable or disable page ratings.
 */
export function PageRatingsSettings(props: SiteOnlyCustomizationProps): React.ReactElement {
    const { site, settings, setSettings } = props;
    const upgrade = useUpgradeSite(site, api.SiteFeatureKey.SitesPageFeedback);
    const enabled = settings.feedback.enabled;

    return (
        <Panel aria-label="Page ratings">
            <PanelBody>
                <FieldGroup orientation="horizontal">
                    <Group>
                        <Group>
                            <Label>Page ratings</Label>
                            <PaidFeatureIndicator upgrade={upgrade} isFeatureActive={enabled} />
                        </Group>
                        <Description>
                            Gather feedback from visitors on the quality of your content.
                        </Description>
                    </Group>
                    <Switch
                        value={enabled}
                        onValueChange={(value) => {
                            if (upgrade && value) {
                                upgrade.onPress();
                                return;
                            }

                            setSettings((prev) => ({
                                ...prev,
                                feedback: { enabled: value },
                            }));
                        }}
                    />
                </FieldGroup>
            </PanelBody>
        </Panel>
    );
}
